// src/API/index.js
import axios from "axios";

export const registerUser = async (formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/register`,
      formData
    );
    // Assuming the token is returned in the response data
    const token = response.data.token;
    if (token) {
      // Save the token to local storage
      localStorage.setItem("token", token);
    }

    return response.data;
  } catch (error) {
    throw new Error("Registration failed: " + error.message);
  }
};

export const loginUser = async (formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/login`,
      formData
    );

    const token = response.data.token;
    const name = response.data.name;

    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("name", name);
      localStorage.setItem("isLoggedIn", "true");
    } else {
      console.error("Token not found in response data");
    }

    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw new Error("Login failed: " + error.message);
  }
};

// src/API/index.js

export const forgotpassword = async (values) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/reset-password`,
      { email: values.email }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error details:",
      error.response ? error.response.data : error.message
    );
    throw new Error(
      "Failed to send password reset email: " +
        (error.response ? error.response.data.message : error.message)
    );
  }
};

export const updatePassword = async (formData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/update/password`,
      formData // Pass the entire formData object including token and passwords
    );
    return response.data;
  } catch (error) {
    throw new Error("Password update failed: " + error.message);
  }
};

export const verifyOtp = async (otp) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/verify/otp`,
      { otp: otp },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    // Log the full error response for debugging
    console.error(
      "Error during OTP verification:",
      error.response || error.message
    );
    throw new Error(
      error.response?.data?.message ||
        "OTP verification failed due to a network issue."
    );
  }
};



export const fetchProfileData = async () => {
  try {
    // Fetch token from localStorage
    const token = localStorage.getItem("token");

    // Make API request to fetch profile data
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/me`, {
      headers: {
        Authorization: token, // Ensure correct header format
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching profile data:",
      error.response ? error.response.data : error.message
    );
    throw new Error(
      "Failed to fetch profile data: " +
        (error.response ? error.response.data.message : error.message)
    );
  }
};

export const updateProfile = async (formData) => {
  try {
    // Fetch the token from localStorage
    const token = localStorage.getItem("token");

    // Send a PATCH request to update the profile data
    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/update/profile`,
      formData,
      {
        headers: {
          Authorization: token, // Include the token in the request headers
        },
      }
    );

    // Return the response data
    return response.data;
  } catch (error) {
    console.error(
      "Error updating profile data:",
      error.response ? error.response.data : error.message
    );
    throw new Error(
      "Failed to update profile: " +
        (error.response ? error.response.data.message : error.message)
    );
  }
};
